import isSelector from './isSelector';
import {getSelectorParts} from './index';
import {PROPERTY_SELECTOR_SIGIL} from '../constants';

/**
 * function to update an object of selectedProperties
 * example obj:
 * resolvedSelectedPropertyMapKey = providerComponentId@PropName
 * {
 *     propertyName: [resolvedSelectedPropertyMapKey, pathValue]
 * }
 * @param {string} propertyName
 * @param {string} propertyValue
 * @param {object} selectedProperties
 */
export default function updatePropertiesWithSelector(
	propertyName,
	propertyValue,
	selectedProperties
) {
	if (!isSelector(propertyValue)) return;

	const [id, name, path] = getSelectorParts(propertyValue);
	const key = `${id}${PROPERTY_SELECTOR_SIGIL}${name}`;
	selectedProperties[propertyName] = [key, path];
}
